import React from 'react'
import { Asset, AssetType } from 'src/constants/types'
import { AutoSuggestFormGroup } from 'src/forms/AutoSuggestFormGroup'
import { InputConfig } from 'src/gameSchemas/types'

interface AssetFormGroupProps {
  formId: string
  inputConfig: InputConfig
  suggestions: Asset[]
  getSuggestions: ({
    query,
    assetTypes,
  }: {
    query: string
    assetTypes: AssetType[]
  }) => Promise<void>
  onSelect: (image: Asset[]) => void
  value: Asset[] | null
}

const AssetFormGroup = (props: AssetFormGroupProps) => {
  const { formId, inputConfig, suggestions, getSuggestions, onSelect, value } =
    props

  return (
    <AutoSuggestFormGroup
      maxTags={1}
      controlId={formId}
      label={inputConfig.label}
      assetTypes={[AssetType.IMAGE, AssetType.ANIMATION, AssetType.VIDEO]}
      suggestions={suggestions}
      onFetchSuggestions={({ query, assetTypes }) =>
        getSuggestions({
          query,
          assetTypes,
        })
      }
      onSelectedSuggestion={onSelect}
      selectedAssets={value}
      placeholder="Add asset"
    />
  )
}

export default AssetFormGroup
